export default "__VITE_ASSET__B7gaKv2M__"